export default __webpack_public_path__ + "4d504c7dbca5d320ea862454f5e7ed11.png";